<template>
  <div class="zj-moble-app-page videoConnection">
   
   <!-- 视频连线邀请 -->
   <div v-show="show">
     <p class="infoTitle">视频连线邀请</p>
     <div class="videoInfo">
       <div class="headInfo">
         <img src="../images/headImg.png">
       </div>
       <div class="callerInfo">指挥中心视频对话邀请，点击接听...</div>
       <div class="isAcept">
         <div class="refuse" @click="handleLeaveRoom"></div>
         <div class="accept"  @click="handleJoinRoom"></div>
       </div>
     </div> 
     <div class="otherTask">
       <div class="otherTaskLeft" @click="lookTask('first')"></div>
       <div class="otherTaskRight" @click="lookTask('second')"></div>
     </div>
   </div>
   <div class="videoBg" v-show="!show">
      <!-- <zj-layout-main > -->
        <!-- zj-layout-main-content -->
        <!-- scrollable -->
        <div class=" bgcolor videobg flexstart " ref="container" style="max-height: 7.5rem;overflow: auto;">
          <div  style="position: relative;" class="videobg">
            <video id="localVideo" ref="localVideo" autoplay muted style="width:2.5rem;height: 2.5rem;object-fit: fill;" @click="getSelfVideo"></video>
            <div class="zj-meeting-remote-peer-statusbar">
              <span class="nickname">{{nick}}</span>
              <span class="audio"></span>
            </div>
          </div>
          <!-- <div class="otherVideoBox" ref="remoteVideos"></div> -->
        </div>

      <!-- </zj-layout-main> -->
      <div class="showTime" id="showTime"></div>
      <div class="icon_box">
        <div class="voiceBox1" @click="handleMute" v-if="!mute"></div>
        <div class="voiceBox2" @click="handleMute" v-if="mute"></div>
      </div>
      <div class="closeBtn"  @click="handleLeaveRoom"></div>
    </div>
  <!--   <remote-script src="//api.map.baidu.com/api?v=3.0&ak=ERZS9uzwv1zEBuSEAxN5DM5qjZBVHIfq"></remote-script> -->
  </div>
</template>
<script>
import ZJApp from "../../../app";
// import MyApis from "../../../../../plugins/emergency/src/apis";

// import "./component/importjs";
// import { Field, Cell, Toast, Indicator } from "mint-ui";
// import waitAll from "../../../../../utils/src/waitAll";
const ZJMeeting = ZJApp.ZJMeeting;
export default {
  name: "videoConnection",
  controller: "UI",
  action: "videoConnection",
  data() { 
    return {
      Location: "南湖市南湖区玉林路101号",
      roomId: 'room2',
      pwd: '123456',
      nick: '大王',
      joined: false,
      mute: false,
      show:true,
      ischangeBig:false, //查看单独某一个人的视频的时候为true
      ExecutId:"",
      second:0,
      minute:0,
      hour:0,
      initTimer:"",
      frontCam: false //使用前置摄像机为true，使用后置为false
    };
  },
  created() {
    this.nick = this.$route.query.Name;
    this.roomId = this.$route.query.RoomId;
    this.ExecutId = this.$route.query.ExecutId;
  },
  mounted() {
      const that = this;
      const signalServer = this.CNF('meetingCenter.signalServer');
      // console.log("signalServer")
      // console.log(signalServer)
      if (!signalServer) {
        this.$message.error('未配置信令服务器');
        return;
      }
      const remoteVideos = {
        appendPeerStream: function(video, peer) {
          // console.log("video")
          // console.log(video)
          video.style.width="2.5rem"
          video.style.height="2.5rem"
          video.style.objectFit="fill"
          video.addEventListener('click',function(){
            if (!that.ischangeBig) {
                 video.style.width="7.5rem"
                video.style.height="7.5rem"
               var parentDom = video.parentNode;
               var nextDom = video.nextElementSibling;
               // eslint-disable-next-line no-undef
               $(parentDom).addClass('meeting-onlyvedio')
               // eslint-disable-next-line no-undef
               $(nextDom).addClass('enlarge-statusbar')
            }else{
               video.style.width="2.5rem"
               video.style.height="2.5rem"
               // eslint-disable-next-line no-undef
                 $(video.parentNode).removeClass('meeting-onlyvedio')
                 // eslint-disable-next-line no-undef
                 $(video.nextElementSibling).removeClass('enlarge-statusbar')
            }
            that.ischangeBig = !that.ischangeBig
          })
          // video.addEventListener('click',that.getOtherVideo(video))
          let div = document.createElement('div');
          div.className = "zj-meeting-remote-peer";
          div.id = 'zj-meeting-remote-peer-' + peer.id;
           // div.addEventListener('click',that.getOtherVideo(video))
          that.$refs.container.appendChild(div);
          div.appendChild(video);
          // div.appendChild(htmlstr);
          let statusDiv = document.createElement('div');
          statusDiv.className = "zj-meeting-remote-peer-statusbar";
          div.appendChild(statusDiv);
          statusDiv.innerHTML = '<span class="nickname">' + peer.nick + '</span>' +
            '<span class="audio"></span>';

        },
        removePeerStream: function(video, peer) {
          // console.log("aaa")
          // console.log(video)
          // console.log(peer)
          // video, peer
          let id = 'zj-meeting-remote-peer-' + peer.id;
          let div = that.$refs.container.querySelector('#' + id);
          that.$refs.container.removeChild(div);         
        },
        setMute: function(id, value) {
          let containerId = 'zj-meeting-remote-peer-' + id;
          let container = that.$refs.container.querySelector('#' + containerId);
          let audioSpan = container.querySelector('span.audio');
          audioSpan.innerHTML = value ? '静音' : '';
        }
      };
      //console.log('signalServer', signalServer);
      this.mc = new ZJMeeting.MeetingCenter({
        debug: false,
        signalServer: signalServer,
        autoConnect: false,
        
        localVideoEl: this.$refs.localVideo,
        remoteVideosEl: remoteVideos,
        autoRemoveVideos: true,
        autoRequestMedia: false,
        enableDataChannels: false,
        media: {
            audio: true,
            video: {
              facingMode: (this.frontCam ? "user" : "environment") // 前置摄像头/默认摄像机
            }
        }
      });
      window.mc = this.mc;

      this.mc.on('error', function(e) {
        that.$message.error(e.toString());
      });

      this.mc.on('readyToCall', function () {
        that.mc.joinRoom({
          name: that.roomId, // 房间名称
          pwd: that.pwd,     // 密码
          nick: that.nick    // 昵称
        });
      });

      this.mc.on('leftRoom', function() {
        setTimeout(function() {
          that.mc.disconnect();
        }, 0);
        that.mc.stopLocalVideo();
        that.mute = false;
      });
      
      this.mc.on('mute', function(e) {
        remoteVideos.setMute(e.id, true);
      });

      this.mc.on('unmute', function(e) {
        remoteVideos.setMute(e.id, false);
      });
    },
    destroyed() {
      if(this.mc) {
        this.mc.destroy();
        this.mc = null;
      }
    },
  methods: {
    GotoBack() {
      this.$router.back(-1);
    },
    lookTask(type){
      let path = "/m/emg/eventsReport?type="+type
      this.$router.push(path)
    },
    // 加入房间
    handleJoinRoom() {
        if (this.joined) {
          return;
        }
        this.joined = true;
        this.mc.startLocalVideo();
        this.mc.connect();
        //显示视频，初始连线状态关闭
        this.show = false;
        //通话计时开始
        this.start()
    },
    handleLeaveRoom() {       
        if (!this.joined) {
          return;
        }
        this.joined = false;
         clearInterval(this.initTimer);
        this.mc.leaveRoom();
         //关闭视频，连线状态关闭
        this.show = true;
      },
    handleMute() {
        if (this.mute) {
          this.mute = false;
          this.mc.unmute();
        }
        else {
          this.mute = true;
          this.mc.mute();
        }
      },
      getSelfVideo(){
         let videoDom = this.$refs.localVideo
         if (!this.ischangeBig) {
              videoDom.style.width="7.5rem"
             videoDom.style.height="7.5rem"
             var parentDom = videoDom.parentNode;
             parentDom.setAttribute('class','meeting-onlyvedio');
              var nextDom = videoDom.nextElementSibling;
               // eslint-disable-next-line no-undef
              $(nextDom).addClass('enlarge-statusbar')
            }else{
               videoDom.style.width="2.5rem"
               videoDom.style.height="2.5rem"
                parentDom = videoDom.parentNode;
               parentDom.removeAttribute('class','meeting-onlyvedio');
               nextDom = videoDom.nextElementSibling;
                // eslint-disable-next-line no-undef
               $(nextDom).removeClass('enlarge-statusbar')
            }
            this.ischangeBig = !this.ischangeBig 
      },
      start(){
       this.initTimer = setInterval(this.animation,1000);
      },
      animation() {
        // var second = this.second;
        // var minute = this.minute;
        // var hour = this.hour
        this.second+=1;
        if(this.second>=60){
            this.second=0;
            this.minute=this.minute+1;
        }
          
        if(this.minute>=60){
            this.minute=0;
            this.hour=this.hour+1;
        }
        if (this.hour==0) {
          document.getElementById('showTime').innerHTML=
          this.toShowtimeStr(this.minute)+':'+this.toShowtimeStr(this.second);
        }else{
          document.getElementById('showTime').innerHTML=
           this.toShowtimeStr(this.hour)+':'+this.toShowtimeStr(this.minute)+':'+this.toShowtimeStr(this.second);
        }
           
 
      },
      toShowtimeStr(value){
        if (value<10) {
           return "0"+value
        }else{
          return value
        }
      }


  }

};
</script>
<style type="text/css" scoped>
.infoTitle{
  font-size:0.34rem;
  color: #333333;
  text-align: center;
  margin:0.33rem auto 0.25rem;
}
.videoInfo{
  width: 6.9rem;
  height: 3.97rem;
  background: url("../images/bigbg.png") no-repeat;
  background-size: cover;
  position: relative;
  margin:0 auto;
  padding-top: 2.2rem;
  box-sizing: border-box;
}
.headInfo{
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  border:1px solid #fff;
  position: absolute;
  left: 50%;
  margin-left: -0.77rem;
  top: 0.46rem;
  z-index: 99;
  padding:0.15rem;
}
.headInfo img{
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.callerInfo{
  font-size: 0.28rem;
  color: #fff;
  text-align: center;
}
.isAcept{
  position: absolute;
  left: 1.82rem;
  bottom: 0.44rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 3.14rem;

}
.refuse{
  width: 0.64rem;
  height: 0.64rem;
  background: url("../images/refuse.png") no-repeat;
   background-size: cover;
}
.accept{
  width: 0.64rem;
  height: 0.64rem;
  background: url("../images/accept.png") no-repeat;
   background-size: cover;
}
.otherTask{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.3rem;
  padding:0 0.3rem;
}
.otherTaskLeft{
  width: 3.31rem;
  height: 1.82rem;
  background: url("../images/renwu.png") no-repeat;
   background-size: cover;
}
.otherTaskRight{
  width: 3.31rem;
  height: 1.82rem;
  background: url("../images/feedback_bg.png") no-repeat;
   background-size: cover;
}
.zj-layout-main-content video{
/*  width: 2.5rem !important;
  height: 2.5rem !important;*/
}
.otherVideoBox{
    display: flex;
    justify-content:flex-start;
    flex-wrap: wrap;
   }
.otherVideoBox video{
  width: 2.5rem !important;
  height: 2.5rem !important;
}
.videoBg{
  width: 100%;
  height: 100%;
  background: #162029;
  position: fixed;
  top: 0;
  left: 0;
}
.closeBtn{
  width: 1.24rem;
  height: 1.79rem;
  background: url("../images/cancle.png") no-repeat;
  position: absolute;
  left: 50%;
  margin-left: -0.62rem;
  bottom: 0.89rem;
}
.flexstart{
  display: flex;
  justify-content:flex-start;
  flex-wrap: wrap;
}
.showTime{
  width: 100%;
  font-size: 0.31rem;
  color: #fff;
  text-align: center;
  position: absolute;
  left: 0;
  bottom: 4.8rem;
  z-index: 99999;
}
.icon_box{
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 2.9rem;
  z-index: 999;
  padding:0 1.14rem;
  box-sizing: border-box;
}
.voiceBox1{
  width: 1.18rem;
  height: 1.68rem;
  background: url("../images/novoice1.png") no-repeat;
  background-size: cover;
}
.voiceBox2{
  width: 1.18rem;
  height: 1.68rem;
  background: url("../images/novoice2.png") no-repeat;
   background-size: cover;
}
</style>